// @module Tavanoteam.Calculator.Calculator
define('Calculator.SquareFoot.Circle.View'
    , [
        'calculator_square_foot_circle.tpl'

        , 'Backbone'
        , 'jQuery'
    ]
    , function (
        calculator_square_foot_circle_tpl

        , Backbone
        , jQuery
    ) {
        'use strict';

        return Backbone.View.extend({

            template: calculator_square_foot_circle_tpl

            , initialize: function (options) {
            }

            , events: {
                'click [data-action="calculate-square-foot-circle"]': 'calculateArea',
                'click [data-action="reset"]': 'resetAllFields'
            }

            , calculateArea: function calculateArea() {
                //input fields
                var radius = $('#square-foot-circle-radius').val();
                //output fields
                var area = $('#square-foot-circle-area');

                var result = Math.PI * parseFloat(radius) * parseFloat(radius);

                area.val(result.toFixed(2));
            }

            , resetAllFields: function resetAllFields() {
                $('.calculator-square-foot-circle-input-fields').find('input:text').val('');
                $('.calculator-square-foot-circle-output-fields').find('input:text').val('');
            }

            , getContext: function getContext()
            {
                return {
                    isActive : true
                }
            }
        });
    });
